<mat-card class="slidecontent">
    <div class="headcontent">
      <div class="pophead">
        <h3>Add Procedure</h3>
        <button mat-icon-button (click)="closeCase(false)">
          <mat-icon class="close" >close</mat-icon>
        </button>
      </div>
  
    </div>
    <div class="dialog_content">
      <mat-form-field appearance="">
          <mat-label>Name </mat-label>
          <input matInput value="" placeholder="Procedure Name" >
        </mat-form-field>

          

     
     
    <!-- <mat-form-field class="">
      <mat-label>Procedure</mat-label>
      <mat-chip-list #chipList aria-label="Fruit selection">
        <mat-chip
          *ngFor="let fruit of fruits"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="remove(fruit)">
          {{fruit}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
        <input
          placeholder="Type & Select Procedure..."
          #fruitInput
          [formControl]="fruitCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)">
      </mat-chip-list>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
          {{fruit}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="">
      <mat-label>Tags</mat-label>
      <mat-chip-list #chipList aria-label="Fruit selection">
        <mat-chip
          *ngFor="let fruit of fruits"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="remove(fruit)">
          {{fruit}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
        <input
          placeholder="Type & Select Procedure..."
          #fruitInput
          [formControl]="fruitCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)">
      </mat-chip-list>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
          {{fruit}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>-->
    <mat-form-field class="">
      <mat-label>Equipment</mat-label>
      <mat-chip-list #chipList aria-label="Fruit selection">
        <mat-chip
          *ngFor="let fruit of fruits"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="remove(fruit)">
          {{fruit}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
        <input
          placeholder="Type & Select Procedure..."
          #fruitInput
          [formControl]="fruitCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)">
      </mat-chip-list>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
          {{fruit}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

  

    <!-- <mat-form-field appearance="">
      <mat-label>Rooms</mat-label>
      <mat-select>
        <mat-option value="1">F1 - 1</mat-option>
        <mat-option value="2">F2 - 1</mat-option>
      </mat-select>
   </mat-form-field> -->



   <div class="dSection">
    <label>Preparation Time (before surgery)</label>
    <div class="prepTime">
      <p><mat-slider  min="1"      max="100000"></mat-slider> 30 min</p>
      <!-- <button mat-icon-button color="primary" >
        <mat-icon>person_add</mat-icon>
      </button> -->
    </div>
  </div>

 
  <div class="dSection">
    <label>Clean Up Time (after surgery)</label>
    <div class="prepTime">
      <p><mat-slider  min="1"      max="100000"></mat-slider> 30 min</p>
      <!-- <button mat-icon-button color="primary" >
        <mat-icon>person_add</mat-icon>
      </button> -->
    </div>
  </div>


  </div>
  
  
    <div class="actionBtn">
      <button mat-flat-button class="calltoaction" type="submit"  color="basic"> Close </button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary">Done</button>
    </div>
  </mat-card>
  

  <div class="overlay" (click)="closeCase(false)" ></div>
  
